// authProvider.js
import { MsalAuthProvider, LoginType } from "react-aad-msal";
import { Logger, LogLevel } from "msal";

// Msal Configurations
const config = {
	auth: {
		// Container app
		authority: process.env.REACT_APP_AUTH_AUTHORITY,
		clientId: process.env.REACT_APP_AUTH_CLIENTID,
		//clientId: "2062c088-8569-4657-9931-763a35402957",
		redirectUri: window.location.origin,
		validateAuthority: true,
		postLogoutRedirectUri: window.location.origin,
		navigateToLoginRequestUrl: false,
	},
	system: {
		logger: new Logger(
			(logLevel, message, containsPii) => {
				console.log("[MSAL]", message);
			},
			{
				level: LogLevel.Error,
				piiLoggingEnabled: true,
			}
		),
	},
	cache: {
		cacheLocation: "localStorage",
		storeAuthStateInCookie: true,
	},
};

// Authentication Parameters
const authenticationParameters = {
	//scopes: ["openid", "profile", "user.read", "api://2062c088-8569-4657-9931-763a35402957/user_impersonation","api://2062c088-8569-4657-9931-763a35402957/read"],
	//scopes: ["api://2062c088-8569-4657-9931-763a35402957/user_impersonation","api://2062c088-8569-4657-9931-763a35402957/read"],
	scopes: [
		"api://" + process.env.REACT_APP_AUTH_SCOPEID + "/user_impersonation",
		"api://" + process.env.REACT_APP_AUTH_SCOPEID + "/read",
	],
};

// Options
const options = {
	loginType: LoginType.Redirect,
	tokenRefreshUri: window.location.origin,
};

export const authProvider = new MsalAuthProvider(
	config,
	authenticationParameters,
	options
);
